import axios from 'axios';
import { getRequest, postRequest } from '../tools/ajax.js'

const ArchiveList = params => postRequest('/api/pc/Archive/ArchiveList', params);

const ChangeStatus = params => postRequest('/api/pc/Archive/ChangeStatus', params);

const UpdateArchive = params => postRequest('/api/pc/Archive/UpdateArchive', params);

const GetCaseTypes = params => getRequest('/api/pc/Archive/GetCaseTypes', params);

const ApproveArchive = params => postRequest('/api/pc/Archive/ApproveArchive', params);

const BackArchive = params => postRequest('/api/pc/Archive/BackArchive', params);

export {
    ArchiveList,ChangeStatus,UpdateArchive,GetCaseTypes,ApproveArchive,BackArchive
}